import React from 'react'
import { Tab, Tabs, LayoutBand } from '@fs/zion-ui'
import { NotFound } from '@fs/zion-router'
import useAdmin from '../hooks/use-admin'

const CentersTable = React.lazy(() => import('../components/AdminConsole/Centers/CentersTable/CentersTable'))
const RolesTable = React.lazy(() => import('../components/AdminConsole/Roles/RolesTable/RolesTable'))
const PartnersView = React.lazy(() => import('../components/AdminConsole/Partners/PartnersView/PartnersView'))

export default function AdminConsole() {
  const { isAdmin, isLoading } = useAdmin()
  if (isLoading) {
    return null
  }
  return (
    <>
      {isAdmin === true ? (
        <LayoutBand>
          <Tabs fullWidth index={0}>
            <Tab title="Centers" to="/centers/admin/centers">
              <CentersTable />
            </Tab>
            <Tab title="Roles" to="/centers/admin/roles">
              <RolesTable />
            </Tab>
            <Tab title="Partners" to="/centers/admin/partners">
              <PartnersView />
            </Tab>
          </Tabs>
        </LayoutBand>
      ) : (
        <NotFound />
      )}
    </>
  )
}
